"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
var problem_schema_1 = require("./problem-schema");
exports.responseSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        autoAdjudicationOutcomeCode: {
            type: ['integer', 'null'],
            enum: Object.values(constants_2.AutoAdjudicationOutcomeCode),
            errorMessage: 'Should equate to a valid auto adjudication code enum value or null',
        },
        autoAdjudicationOutcomeTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        decisionTypeCode: {
            type: ['integer', 'null'],
            // TODO: remove '' from enum once DMP bug is fixed
            enum: __spreadArrays(Object.values(constants_1.DecisionTypeCode), ['']),
            errorMessage: 'Should equate to a valid decision type code enum value or null',
        },
        problems: {
            type: ['array', 'null'],
            items: problem_schema_1.problemSchema,
        },
    },
};
